import classes from './CatalogItem.module.scss'
import BitmanItemImage from '../../../../accests/image/bitmanImage.png'
import ShopIcon from '../../../../accests/image/shoppMenuIcon.svg'
import Button from '../Button/Button'
import ComparisonIcon from '../../../../accests/image/comparison.svg'
import { text } from '../../../../translate'
import {
   addRemoveCompareById,
   addRemoveVisitedById,
   formatingNumber,
} from '../../comFn'
import { imageUrl } from '../../../config/config'

import ButtonFavorite from '../ButtonFavorite/ButtonFavorite'
import { useNavigate } from 'react-router-dom'
import React, {useState} from "react";
import ModalCallback from "../../ModalCallback/ModalCallback";
import PopupBuyOneClick from "../../popupBuyOneClick/popupBuyOneClick";

const CatalogItem = ({
   title,
   hashrate,
   algorithm,
   coins,
   hit,
   is_new,
   price,
   total_price,
   id,
   discount,
   photo_urls,
   hashrate_um,
   is_in_stock,
   tags,
   brand,
   name,
   showModal,
   slug_name,
   is_used,
   is_on_the_way,
   contact,
    number,
    count
}) => {
   const lang = 'ru'
   const navigate = useNavigate()
   const [showModalOrder, setShowModalOrder] = useState(false)
   const [showModalBuyOneClick, setShowModalBuyOneClick] = useState(false)

   const handleClickLink = () => {
      window.scroll(0, 0)
      addRemoveVisitedById(id)
      navigate(`/asic-miners/${slug_name}`)
   }

    const getCardClass = (index, count) => {
        let classStr = classes.wrapperMini;

        // Верхние углы для первой строки
        if (index === 0) classStr += ` ${classes.wrapperMini1}`;
        if (index === 1) classStr += ` ${classes.wrapperMini2}`;

        if (count === 1) {
            // Если карточка единственная, добавляем оба нижних скругления
            classStr += ` ${classes.wrapperMini2} ${classes.wrapperMini3} ${classes.wrapperMini4}`;
        } else if (count % 2 === 0) {
            // Чётное количество карточек: последние две карточки в нижнем ряду
            if (index === count - 2) classStr += ` ${classes.wrapperMini3}`; // нижний левый
            if (index === count - 1) classStr += ` ${classes.wrapperMini4}`; // нижний правый
        } else {
            // Нечётное количество карточек (больше одной)
            // Если хотим, чтобы последняя карточка имела оба скругления:
            if (index === count - 1) classStr += ` ${classes.wrapperMini3} ${classes.wrapperMini4}`;
            // А предпоследняя карточка, если нужна, получит только нижнее правое скругление:
            if (index === count - 2) classStr += ` ${classes.wrapperMini4}`;
        }

        return classStr;
    };

   return (
      <div className={getCardClass(number, count)}>
         <div className={classes.favoriteBlock}>
            <ButtonFavorite itemId={id} />
         </div>
         <div className={classes.mainImage} onClick={() => addRemoveVisitedById(id)}>
            <div onClick={() => handleClickLink()} className={classes.linkImg}>
               <img
                  className={classes.imageItem}
                  src={!!photo_urls?.length ? `${imageUrl}${photo_urls[0]}` : BitmanItemImage}
                  alt=''
               />
            </div>
         </div>
         <div className={classes.labels} style={{padding: '7px 12px 5px 12px'}} onClick={() => handleClickLink()}>
            {!!is_in_stock && (
                <div className={classes.hit}>{text[lang].mainPage.catalogItem.is_in_stock}</div>
            )}
            {!!is_new && (
                <div className={classes.sallary}>{text[lang].mainPage.catalogItem.isNew}</div>
            )}
            {!!hit &&
                <div className={classes.newItem}>{text[lang].mainPage.catalogItem.hit}</div>
            }
            {!!is_used && (
                <div className={classes.hit} style={{background: '#a6b94e', color:'white', border: '1px solid #a6b94e', minWidth:'min-content'}}>{text[lang].mainPage.catalogItem.is_used}</div>
            )}
            {!!is_on_the_way && (
                <div className={classes.newItem} style={{color:'rgb(67, 188, 255)', border: '1px solid rgb(67, 188, 255)'}}>
                   {text[lang].mainPage.catalogItem.is_on_the_way}
                </div>
            )}
            {tags?.map((tag) => (
                <div
                    className={classes.otherTag}
                    key={tag.id}
                    style={{
                       color: tag.color ?? '#80899c',
                       border: `1px solid ${tag.color ?? '#80899c'}`,
                    }}
                >
                   {tag?.value}
                </div>
            ))}
         </div>
         <div className={classes.description+' '+classes.descriptionMini} onClick={() => handleClickLink()} style={{paddingBottom:0}}>
            {/* <div className={classes.name}>{title}</div> */}
            <div className={classes.nameMini}>
               {brand?.value} <br/> {name} {hashrate} {hashrate_um?.value}
            </div>
         </div>
         {is_in_stock ? <div className={classes.pricesWrapper+' '+classes.pricesWrapperMini}>
            <div className={classes.discountWrapper}>
               {!!discount && (
                  <>
                     <div className={classes.price}>{formatingNumber(price)}</div>
                     <div className={classes.salleryPrice}>-{formatingNumber(discount)} ₽</div>
                  </>
               )}
            </div>
            <div className={classes.total_price}>{formatingNumber(total_price)} ₽</div>
         </div>:
             <div className={classes.pricesWrapper}>
                <div className={classes.discountWrapper}></div>
                <div className={classes.total_price}>{text[lang].mainPage.sendPrice}</div>
             </div>
         }
         <div className={classes.activeBlockMini}>
            {is_in_stock && <Button itemId={id} photo={photo_urls} name={title}>
               <img src={ShopIcon} alt='shopIcon' /> {text[lang].mainPage.inBasket}
            </Button>}
            {!is_in_stock && <Button onClick={()=>{setShowModalOrder(true)}}>
               {text[lang].mainPage.order}
            </Button>}
            <div className={classes.buyOneClick} onClick={()=>setShowModalBuyOneClick(true)}>
               {text[lang].mainPage.buyOneClick}
            </div>
         </div>
         {showModalOrder && <ModalCallback onClose={() => setShowModalOrder(false)}
                                      modalSlug={id}
                                      type={'asic'}
         />}
         <PopupBuyOneClick open={showModalBuyOneClick} setOpen={setShowModalBuyOneClick} item={brand?.value+' '+name+' '+hashrate+hashrate_um?.value} contact={contact}/>
      </div>
   )
}

export default CatalogItem
